export default {
  name: 'countries',
}
